import React, {useContext, useEffect, useState} from 'react';

import {AppContext} from '../../../../../AppModule/Context';
import {withExpertHomeContext} from '../../../../../screens/ExpertHome/ExpertHomeContextProvider';

import AiBotPillComponent from '../aiBotPillComponent/aiBotPillComponent';
import DropDownV2 from '../../dropDownV2/dropDownV2';
import MentorPillComponent from '../mentorPillComponent/mentorPillComponent';

import Check from '../../../../../assets/svgComponents/Check';
import ForwardIcon from '../../../../../assets/svgComponents/LeftNavigationIcons/ForwardIcon';

import utilsService from '../../../../../services/utilsService';
import VIDABOO_CONSTANTS from '../../../../../config/consts';

import './mentorAiPillSelectorComponent.css';

const MentorAiPillSelectorComponent = ({
  isDisabled = false,
  showAiBotInDD = false,
  showAllMentorsOfWidget = false, // if this is true all the mentors inside the widget will be shown otherwise all the mentors whose mentorUserId is same as that of selectedMentorId, those will be shown
  showMentorEmail = false,
  customDdItems = [],
  expertHomeContext = {},
  onlyVisibleMentorId = null,
  roomExtendedMentorDto = {},
  selectedMentorId = '',
  selectorTitle = null,
  selectedWidgetId = '',
  onMentorSelected = () => {},
}) => {
  const context = useContext(AppContext);

  const [selectedWidgetName, setSelectedWidgetName] = useState(null);
  const [selectedExtendedMentorDto, setSelectedExtendedMentorDto] =
    useState(null);
  const [isDDOpen, setIsDDOpen] = useState(false);
  const [ddOptions, setDdOptions] = useState([]);

  useEffect(() => {
    updateData();
  }, [
    expertHomeContext.widgetDtos,
    expertHomeContext.selectedMentorDtos,
    onlyVisibleMentorId,
    selectedMentorId,
    customDdItems,
  ]);

  useEffect(() => {
    if (isDisabled && isDDOpen) {
      setIsDDOpen(false);
    }
  }, [isDisabled]);

  const updateData = () => {
    let ddOptions = [],
      selectedExtendedMentorDto = null;
    if (showAllMentorsOfWidget) {
      const widgetDto = expertHomeContext.widgetDtos.find(
        (wDto) => wDto.widgetId === selectedWidgetId,
      );
      Object.values(widgetDto.mentorsControlMapDto).forEach(
        (widgetMentorCtrlDto) => {
          if (
            onlyVisibleMentorId &&
            widgetMentorCtrlDto.extendedMentorDto.mentorDto.mentorId !==
              onlyVisibleMentorId
          )
            return;
          const isSelected =
            widgetMentorCtrlDto.extendedMentorDto.mentorDto.mentorId ===
            selectedMentorId;
          const isMe =
            widgetMentorCtrlDto.extendedMentorDto.mentorDto.mentorOwnerId ===
            context.currentUser.userId;
          const option = {
            id: widgetMentorCtrlDto.extendedMentorDto.mentorDto.mentorId,
            showBoldText: isMe,
            LeftComponent: (
              <MentorPillComponent
                showMentorEmail={showMentorEmail}
                extendedMentorDto={widgetMentorCtrlDto.extendedMentorDto}
                widgetName={widgetDto.widgetAppCtrlDto.name}
                toolTipPosition="right"
              />
            ),
            btnText: context.isAccountManager
              ? widgetMentorCtrlDto.extendedMentorDto.mentorDto.displayName
              : widgetDto.widgetAppCtrlDto.name,
            RightComponent: isSelected ? <Check /> : null,
          };
          ddOptions.push(option);
          if (isSelected) {
            selectedExtendedMentorDto = widgetMentorCtrlDto.extendedMentorDto;
          }
        },
      );
      if (showAiBotInDD) {
        const option = {
          id: VIDABOO_CONSTANTS.CHAT_PARTICIPANT_TYPES.OONI_AI,
          LeftComponent: (
            <AiBotPillComponent
              assistantName={
                roomExtendedMentorDto?.mentorDto?.appControlDto?.assistantName
              }
              widgetName={widgetDto.widgetAppCtrlDto.name}
            />
          ),
          btnText: utilsService.getAssistantName(
            roomExtendedMentorDto?.mentorDto?.appControlDto?.assistantName,
          ),
          RightComponent: !selectedMentorId ? <Check /> : null,
        };
        ddOptions.push(option);
        if (!selectedMentorId) {
          selectedExtendedMentorDto = null;
        }
      }
      setSelectedWidgetName(widgetDto.widgetAppCtrlDto.name);
      setSelectedExtendedMentorDto(selectedExtendedMentorDto);
    } else {
      expertHomeContext.widgetDtos.forEach((widgetDto) => {
        Object.values(widgetDto.mentorsControlMapDto).forEach(
          (widgetMentorCtrlDto) => {
            if (
              widgetMentorCtrlDto.extendedMentorDto.mentorDto.mentorOwnerId ===
              context.currentUser.userId
            ) {
              const isSelected =
                widgetMentorCtrlDto.extendedMentorDto.mentorDto.mentorId ===
                selectedMentorId;
              const option = {
                id: widgetMentorCtrlDto.extendedMentorDto.mentorDto.mentorId,
                isSelected,
                LeftComponent: (
                  <MentorPillComponent
                    showMentorEmail={showMentorEmail}
                    extendedMentorDto={widgetMentorCtrlDto.extendedMentorDto}
                    widgetName={widgetDto.widgetAppCtrlDto.name}
                    toolTipPosition="right"
                  />
                ),
                btnText: context.isAccountManager
                  ? widgetMentorCtrlDto.extendedMentorDto.mentorDto.displayName
                  : widgetDto.widgetAppCtrlDto.name,
                RightComponent: (
                  <div className="et-v2-maps-mentor-profile-name-wrap">
                    <div>-</div>
                    <div className="et-v2-maps-mentor-profile-name">
                      {
                        widgetMentorCtrlDto.extendedMentorDto.mentorDto
                          .profileName
                      }
                    </div>
                  </div>
                ),
              };
              ddOptions.push(option);
              if (isSelected) {
                setSelectedWidgetName(widgetDto.widgetAppCtrlDto.name);
                setSelectedExtendedMentorDto(
                  widgetMentorCtrlDto.extendedMentorDto,
                );
              }
            }
          },
        );
      });
    }
    if (customDdItems?.length) {
      ddOptions = [...ddOptions, ...customDdItems];
    }
    setDdOptions(ddOptions);
  };

  const onDropDownClick = () => {
    if (!isDisabled) {
      setIsDDOpen(!isDDOpen);
    }
  };

  return (
    <div className="et-v2-mentor-pill-selector-container">
      <div
        className={`et-v2-maps-default-mentor-pill-wrap ${isDisabled ? 'et-v2-maps-default-mentor-pill-wrap-disabled' : ''}`}
        onClick={onDropDownClick}>
        {showAiBotInDD && !selectedMentorId ? (
          <div
            className={`et-v2-maps-mentor-down-arrow-wrap ${isDDOpen ? 'et-v2-maps-mda-dd-open' : ''}`}>
            <div className="et-v2-maps-ai-bot-wrap">
              <AiBotPillComponent
                assistantName={
                  roomExtendedMentorDto?.mentorDto?.appControlDto?.assistantName
                }
                widgetName={selectedWidgetName}
              />
            </div>
            <div
              className={`${
                isDDOpen
                  ? 'et-v2-maps-up-arrow-icon'
                  : 'et-v2-maps-down-arrow-icon'
              }`}>
              <ForwardIcon />
            </div>
          </div>
        ) : (
          <div
            className={`${selectedExtendedMentorDto ? 'et-v2-maps-mentor-down-arrow-wrap' : ''} ${isDDOpen ? 'et-v2-maps-mda-dd-open' : ''}`}>
            {selectedExtendedMentorDto && (
              <MentorPillComponent
                showMentorEmail={showMentorEmail}
                extendedMentorDto={selectedExtendedMentorDto}
                widgetName={selectedWidgetName}
                toolTipPosition="right"
              />
            )}
            <div
              className={`${
                isDDOpen
                  ? 'et-v2-maps-up-arrow-icon'
                  : 'et-v2-maps-down-arrow-icon'
              }`}>
              <ForwardIcon />
            </div>
          </div>
        )}
      </div>
      {isDDOpen && !isDisabled && (
        <div className="et-v2-maps-mentor-pills-dd-wrap">
          {selectorTitle && (
            <div className="et-v2-mps-mentor-pills-dd-half-private-title">
              {selectorTitle}
            </div>
          )}
          <DropDownV2
            showButtonUI={false}
            options={ddOptions}
            onClose={() => setIsDDOpen(false)}
            onItemSelected={(mentorId) => {
              setIsDDOpen(false);
              onMentorSelected(mentorId);
            }}
          />
        </div>
      )}
    </div>
  );
};

export default withExpertHomeContext(MentorAiPillSelectorComponent);
